export default "__VITE_ASSET__C6u0Pnwh__"